import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div className="footer">
      <p>&copy; {new Date().getFullYear()} Sign Blast Pty Ltd. All rights reserved.</p>
    </div>
  );
};

export default Footer;
